var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel"},[(_vm.device)?_c('div',{staticClass:"carousel-inner"},[_vm._l((_vm.devices),function(device,index){return [_c('carousel-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentItem === index),expression:"currentItem === index"}],key:device._id,attrs:{"device":device}})]})],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }